import React from "react";
import NavBar from "../components/NavBar";
import ApplyLoanForm from "../components/ApplyLoanForm";
import Footer from "../components/Footer";

const ApplyForLoans = () => {
    return(
        <div>
            <NavBar/>
            <ApplyLoanForm/>
            <Footer/>
        </div>
    )
}

export default ApplyForLoans;